$(() => {
  const selector = 'select.navigation'
  const change = event => {
    const href = event.target.value
    window.location.href = href
  }
  $(document).on('change', selector, change)
})
